<template>
  <div class="h-full">
    <div class="bg-white overflow-hidden">
      <table class="min-w-full divide-y divide-gray-200 text-left">
        <thead class="bg-gray-50">
        <tr>
          <th scope="col" class="px-6 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
            Дата
          </th>
          <th scope="col" class="px-6 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
            Сервис
          </th>
          <th scope="col" class="px-6 py-2 min-w-200 text-xs font-medium text-gray-500 uppercase tracking-wider">
            Сообщение
          </th>
        </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
        <tr class="hover:bg-gray-50 transition-colors">
          <td class="px-6 py-2 whitespace-nowrap text-sm font-medium text-gray-900">
            2025-05-05 10:05:05.125
          </td>
          <td class="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
            CRM
          </td>
          <td class="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
            322kjh23
          </td>
        </tr>

        <tr class="hover:bg-gray-50 transition-colors">
          <td class="px-6 py-2 whitespace-nowrap text-sm font-medium text-gray-900">
            2025-05-05 10:05:05.122
          </td>
          <td class="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
            CRM
          </td>
          <td class="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
            igyuo76
          </td>
        </tr>
        <tr class="hover:bg-gray-50 transition-colors">
          <td class="px-6 py-2 whitespace-nowrap text-sm font-medium text-gray-900">
            2025-05-05 10:05:05.120
          </td>
          <td class="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
            CRM
          </td>
          <td class="px-6 py-2 text-sm text-gray-500">
            873 лррыовгщыршгынпшщывпн дшнпгае енша нв нл ас лнеа лнелнв  43434
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="bg-gray-50 px-6 py-3 flex items-center justify-between border-t border-gray-200">
      <div class="flex-1 flex justify-between sm:hidden">
        <a href="#" class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
          Назад
        </a>
        <a href="#" class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
          Вперед
        </a>
      </div>
      <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
        <div>
          <p class="text-sm text-gray-700">
            Показаны
            <span class="font-medium">1</span>
            -
            <span class="font-medium">3</span>
            из
            <span class="font-medium">3</span>
          </p>
        </div>
        <div>
          <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
            <a href="#" class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
              <span class="sr-only">Назад</span>
              &larr;
            </a>
            <a href="#" aria-current="page" class="z-10 bg-indigo-50 border-indigo-500 text-indigo-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium">
              1
            </a>
            <a href="#" class="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium">
              2
            </a>
            <a href="#" class="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium">
              3
            </a>
            <a href="#" class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
              <span class="sr-only">Вперед</span>
              &rarr;
            </a>
          </nav>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>

</script>

<style scoped>

</style>